import React from "react";

import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import Button from "components/Button";
import { IRemoveDialog } from "../../interfaces/removedialog.interface";
import { useTranslation } from "react-i18next";

export const RemoveDialog = (props: IRemoveDialog) => {
    const { t } = useTranslation();
    const { openDialog, setDialogOpen, deleteResult, deleteTemplate } = props;
    const handleClose = () => {
        setDialogOpen(false);
    };
    return (
        <Dialog open={openDialog} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
            <DialogTitle id="alert-dialog-title">{`${t("reports.remove_report_template", "Remove report template")}?`}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">{t("reports.are_you_sure_you_want_to_delete_the_report_template", "Are you sure you want to delete the report template? Your choice cannot be undone")}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} variant="outlined">
                    {t("global.cancel", "Cancel")}
                </Button>
                <Button result={deleteResult} onClick={deleteTemplate} color="primary" autoFocus>
                    {t("global.yes_im_sure", "Yes, I'm sure")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
